import React from 'react';
import type { SellerCampaignCount } from '../sellerCampaignCounts';
export function SellerCampaignCounts({ counts, loading = false, error = false }: { counts?: SellerCampaignCount; loading?: boolean; error?: boolean }) {
  if (loading || error) return <span className="seller-campaign-counts">{loading ? 'Loading campaigns…' : 'Campaign counts unavailable'}</span>;
  return <div className="seller-campaign-counts" aria-label={`${counts?.total ?? 0} campaigns`}>
    <strong>{counts?.total ?? 0} campaigns</strong>
    <span><i className="active" />{counts?.active ?? 0} active</span>
    <span><i className="paused" />{counts?.paused ?? 0} paused</span>
    <span><i className="archived" />{counts?.archived ?? 0} archived</span>
  </div>;
}
